import { Link, NavLink } from "react-router-dom";
import { ArrowLeft, AudioWaveform, SlidersHorizontal, Video } from "lucide-react";

export default function PublicToolsLayout({ children }) {
  return (
    <div className="ph-no-capture min-h-screen overflow-x-hidden bg-background text-foreground">
      <header className="border-b border-border bg-panel">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3 px-4 py-4 sm:px-6">
          <Link to="/" className="inline-flex min-h-11 items-center gap-2 font-display text-lg font-bold">
            <AudioWaveform className="h-6 w-6 text-signal" /> SteelMora
          </Link>
          <nav aria-label="Herramientas gratuitas" className="flex flex-wrap gap-2">
            {[{ to: "/pitch-tempo", label: "Tono y BPM", Icon: SlidersHorizontal },
              { to: "/video-audio", label: "Audio de video", Icon: Video },
              { to: "/creator-studio", label: "Creator Studio", Icon: Video }].map(({ to, label, Icon }) => (
              <NavLink key={to} to={to} className={({ isActive }) => `inline-flex min-h-11 items-center gap-2 rounded px-3 text-sm font-semibold ${isActive ? "bg-signal/10 text-signal" : "text-muted-foreground hover:text-foreground"}`}>
                <Icon className="h-4 w-4" />{label}
              </NavLink>
            ))}
            <Link to="/" aria-label="Volver al inicio" title="Volver al inicio" className="grid h-11 w-11 place-items-center text-muted-foreground hover:text-foreground">
              <ArrowLeft className="h-4 w-4" />
            </Link>
          </nav>
        </div>
      </header>
      <main className="mx-auto min-w-0 max-w-6xl px-4 py-6 sm:px-6 lg:py-8">{children}</main>
    </div>
  );
}
